export default "__VITE_ASSET__BFb_73Hf__"